module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"home":{"title":"Updates"},"functions":{"updateBelege":"Belege aktualisieren"},"messages":{}},"en":{"home":{"title":"Updates"},"functions":{"updateBelege":"Update Belege"},"messages":{}}}')
  delete Component.options._Ctor
}
